export default (function () {
  return {
    panelSides: {
      leftA: {},
      leftB: null,
      rightA: {},
      rightB: null
    },
    openFloatPanel: false,
    floatPanel: {
      panelComponent: '',
      moduleComponent: ''
    },
    floatPanelTitle: '',
    selectedQuery: {}
  };
});